var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 32C21.5 32 0 53.5 0 80V144C0 152.875 7.125 160 16 160H96V80C96 53.5 74.5 32 48 32ZM256 380.625V320H480V128C480 75 437 32 384 32H111.625C121.75 45.375 128 61.875 128 80V384C128 422.875 162.625 453.625 202.75 447.125C234.25 442 256 412.5 256 380.625ZM288 352V384C288 436.875 245 480 192 480H464C525.875 480 576 429.875 576 368C576 359.125 568.875 352 560 352H288Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.09bad782c057034227fdf3590f06aa7d.svg";
export { ForwardRef as ReactComponent };